module.exports = {"320803100":"淮城镇","320803101":"平桥镇","320803102":"上河镇","320803103":"马甸镇","320803104":"朱桥镇","320803105":"溪河镇","320803106":"施河镇","320803107":"车桥镇","320803108":"泾口镇","320803109":"流均镇","320803110":"博里镇","320803111":"仇桥镇","320803112":"复兴镇","320803113":"苏嘴镇","320803114":"钦工镇","320803115":"顺河镇","320803116":"季桥镇","320803117":"席桥镇","320803118":"林集镇","320803119":"南闸镇","320803200":"建淮乡","320803201":"茭陵乡","320803202":"宋集乡","320803203":"城东乡","320803204":"三堡乡","320803400":"白马湖农场","320803401":"经济开发区","320803402":"淮安新材料产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320803.json
// module id = 824
// module chunks = 0